// import React from "react";
// import { Route, Routes, Navigate } from "react-router-dom";
// import SiteManagement from "../screens/Managements/SiteManagement.tsx";
// import LayoutComponent from "../components/layout/Layout.tsx"
// import MaterialCategoryMaster from "../screens/Masters/MaterialCategoryMaster.tsx";
// import Login from "../screens/Login.tsx";
// import SiteManagementPreview from "../screens/Managements/Sitemanagement_preview.tsx";
// import ForgetPassword from "../screens/forgetpassword.tsx";
// import AuthGuard from '../../src/components/AuthGuard.tsx';
// const AppRoutes = () => {
//     return (
//         <Routes>
//             {/* Public Routes - No AuthGuard */}
//             <Route path="/login" element={<Login />} />
//             {/* <Route path="/setpassword" element={<SetPassword />} /> */}
//             <Route path="/forgetpassword" element={<ForgetPassword />} />

//             {/* Protected Routes - Wrapped in AuthGuard */}
//             <Route element={<AuthGuard><LayoutComponent /></AuthGuard>}>
               
//                 <Route path="site-management" element={<SiteManagement />} />
//                 <Route path="site-management-preview/:siteId" element={<SiteManagementPreview />} />
//                 <Route path="/masters/material-category-master" element={< MaterialCategoryMaster />} />
//             </Route>

//             {/* Fallback route */}
//             <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//     );
// };

// export default AppRoutes;


import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LayoutComponent from "../components/layout/Layout.tsx"
import Login from "../screens/Login.tsx";
import ForgetPassword from "../screens/forgetpassword.tsx";
import AuthGuard from '../../src/components/AuthGuard.tsx';
import Dashboard from "../screens/dashboard/Dashboard.tsx";
import Clients from "../screens/clients/Clients.tsx"
import Vendors from "../screens/vendors/Vendors.tsx";
import Requests from "../screens/requests/Requests.tsx";
import Assignments from "../screens/assignments/Assignments.tsx";
import ServiceMaster from "../screens/Masters/ServiceMaster.tsx"
import SubServiceMaster from "../screens/Masters/SubServiceMaster.tsx"
import SiteManagement from "../screens/Managements/SiteManagement.tsx"
import Settings from "../screens/settings/Settings.tsx";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />

            <Route element={<AuthGuard><LayoutComponent /></AuthGuard>}>
               
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="requests" element={<Requests />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="masters/service-master" element={< ServiceMaster />} />
            <Route path="masters/sub-service-master" element={< SubServiceMaster />} />
            <Route path="site" element={<SiteManagement />} />
            <Route path="settings" element={<Settings />} />
            </Route>
            
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

export default AppRoutes;
